function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { Group } from '../../../containers';
import { Icon } from '../../../foundations/Icon';
import { useBreakpoint } from '../../../theme';
import { MelioWrapper } from '../../../theme/MelioWrapper';
import { useTestId } from '../../../utils';
import { useMultiStyleConfig } from '../../../utils/use-style-config';
import { NakedButton } from '../../action';
import { Box } from '../../internal';
import { Link } from '../../navigation';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var getIconByType = type => {
  var iconMap = {
    success: /*#__PURE__*/_jsx(Icon, {
      type: "checked",
      color: "inverted",
      "aria-hidden": true
    }),
    error: /*#__PURE__*/_jsx(Icon, {
      type: "error",
      color: "inverted",
      "aria-hidden": true
    }),
    info: null
  };
  return iconMap[type];
};

export var Toast = _ref => {
  var {
    id,
    onClose,
    type,
    title,
    actionType = 'button',
    actionText,
    onAction,
    'data-testid': dataTestId = 'toast'
  } = _ref;
  var {
    isExtraSmallScreen
  } = useBreakpoint();
  var styles = useMultiStyleConfig('Toast', {
    type,
    isMobile: isExtraSmallScreen
  });
  var getTestId = useTestId(dataTestId);
  return /*#__PURE__*/_jsx(MelioWrapper, {
    background: "transparent",
    children: /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
      id: "toast-".concat(id),
      __css: styles['toast'],
      "data-component": "Toast"
    }, getTestId("".concat(id))), {}, {
      role: "alert",
      children: [/*#__PURE__*/_jsxs(Group, {
        spacing: "xs",
        alignItems: "center",
        children: [getIconByType(type), title && /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
          __css: styles['content']
        }, getTestId('title')), {}, {
          children: title
        }))]
      }), actionType === 'button' && actionText && onAction && /*#__PURE__*/_jsx(NakedButton, _objectSpread(_objectSpread({}, getTestId('action')), {}, {
        variant: "invert",
        size: "small",
        onClick: () => onAction === null || onAction === void 0 ? void 0 : onAction(() => onClose()),
        label: actionText
      })), actionType === 'link' && actionText && onAction && /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, getTestId('action')), {}, {
        href: "#",
        variant: "standalone",
        color: "inherit",
        label: actionText,
        onClick: () => onAction === null || onAction === void 0 ? void 0 : onAction(() => onClose()),
        size: "small"
      }))]
    }))
  });
};
//# sourceMappingURL=Toast.js.map